function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8354"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5680"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40345",
    d: "M1262.807 289.369h-27.561c-1.053-.257-1.391-.7-1.392-1.879q-.007-8.268 0-16.536v-24.125c0-.25-.007-.5.009-.749a1.671 1.671 0 0 1 1.412-1.639 14.387 14.387 0 0 1 3.45 0c.216.112.22.321.229.522.016.341 0 .683.009 1.024a1.475 1.475 0 0 0 1.214 1.589c1.216-.053 1.656-.513 1.661-1.743 0-.776-.007-1.552.006-2.328 0-.207-.041-.446.2-.578.309.226.2.562.215.858.029.544.044.578.6.58 1.569.008 3.138 0 4.707 0a1.906 1.906 0 0 1 .736.076c.211.117.209.327.218.526.016.339-.011.68.017 1.019a1.6 1.6 0 0 0 1.2 1.575 1.5 1.5 0 0 0 1.743-1.5c.034-.341.014-.682.029-1.022.01-.213-.014-.442.2-.589a1.662 1.662 0 0 1 .734-.089h4.661c.64 0 .643-.022.668-.651.013-.329-.105-.692.19-.968.3.113.218.381.222.593.016.855.026 1.712 0 2.566a1.519 1.519 0 0 0 1.089 1.646c1.215.061 1.779-.473 1.793-1.7 0-.31-.008-.621.008-.931a.534.534 0 0 1 .182-.458 3.735 3.735 0 0 1 1.665-.03 1.882 1.882 0 0 1 1.291 2.039c-.021 4.468-.009 8.936-.009 13.4a3.674 3.674 0 0 1-.037.606.946.946 0 0 1-.355.633q-2.422 2.428-4.849 4.851a.985.985 0 0 1-.632.365 4.711 4.711 0 0 1-.795.038h-11.467a2.95 2.95 0 0 0-.973.095.478.478 0 0 0-.368.48.487.487 0 0 0 .357.49 2.333 2.333 0 0 0 .878.088h10.063a3.444 3.444 0 0 1 .792.042c.227.066.254.2.126.385a2.878 2.878 0 0 1-.347.379q-3.575 3.577-7.151 7.152a1.329 1.329 0 0 1-.716.5c-.9.069-1.809.016-2.713.032-.2 0-.406-.005-.608.006-.462.025-.682.2-.688.531s.212.524.67.544.9 0 1.357.008a1.537 1.537 0 0 1 .6.067c.205.117.1.255.017.38a2.241 2.241 0 0 0-.338.484 24.61 24.61 0 0 1-.4 2.532 12.652 12.652 0 0 1-1.338 1.422 4.037 4.037 0 0 0-.514.6.549.549 0 0 0 .061.762.555.555 0 0 0 .8-.029c.448-.409.86-.854 1.294-1.278a2.382 2.382 0 0 1 .526-.457 12.414 12.414 0 0 1 2.067-.34 2 2 0 0 0 1.259-.617c1-1.042 2.037-2.054 3.062-3.075a1.152 1.152 0 0 1 .652-.423c.8-.079 1.592-.03 2.387-.036 1.265-.009 2.529 0 3.794 0a2.864 2.864 0 0 0 .56-.029.494.494 0 0 0 .445-.518.468.468 0 0 0-.452-.5 3.957 3.957 0 0 0-.561-.023h-4.028a2.678 2.678 0 0 1-.7-.046c-.2-.065-.225-.189-.116-.357a2.218 2.218 0 0 1 .311-.349q3.658-3.661 7.318-7.32a2.055 2.055 0 0 1 .351-.308c.179-.112.292-.057.351.138a2.941 2.941 0 0 1 .048.747V287.585c-.024 1.131-.336 1.527-1.396 1.784z",
    transform: "translate(-1229.487 -241.369)",
    style: {
      fill: "#e0e0df"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40346",
    d: "M1483.538 437.539c0 .9.013 1.81.013 2.715 0 6.32-.012 12.64.014 18.959a1.916 1.916 0 0 1-1.233 2.062h-1.969a1.823 1.823 0 0 0 1.237-2.034c-.032-6.582-.018-13.164-.019-19.747a5.593 5.593 0 0 1 1.957-1.955z",
    transform: "translate(-1447.044 -413.275)",
    style: {
      fill: "#c0c0bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40347",
    d: "m1363.969 378.407.093-.033a2.257 2.257 0 0 1 1.184 1.141c-.027.259-.23.4-.391.562q-1.7 1.708-3.406 3.41c-.11.11-.223.218-.329.333-.531.573-.52.885.051 1.4.039.3-.211.436-.378.6q-4.564 4.577-9.137 9.146l-4.273 4.273c-.5.5-.553.5-1.049 0-.377-.374-.749-.753-1.127-1.125a1.368 1.368 0 0 1-.345-.494c.1-.279.392-.4.533-.643a4.165 4.165 0 0 1 1.429-1.428c.127-.114.261-.222.381-.342q3.734-3.732 7.464-7.466c.109-.109.205-.232.307-.348a4.423 4.423 0 0 1 1.472-1.474c.613-.6 1.233-1.191 1.838-1.8q1.867-1.87 3.721-3.752a7.425 7.425 0 0 1 1.962-1.96z",
    transform: "translate(-1327.457 -361.06)",
    style: {
      fill: "#0354a3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40348",
    d: "M1340.627 413.521c.59.578 1.185 1.15 1.766 1.737.165.166.266.2.449.013q7.019-7.042 14.049-14.074a.259.259 0 0 0 .027-.038 6.387 6.387 0 0 0 1.533-1.321c1.025-1.019 2.043-2.044 3.067-3.063.162-.161.3-.362.56-.392.513.307 1.02.62 1.147 1.275l-3.507 3.56-1.957 1.956c-1.375 1.365-2.753 2.725-4.122 4.1s-2.75 2.772-4.125 4.159a4.039 4.039 0 0 1-1.415 1.422c-1.029 1.017-2.111 1.987-3.069 3.068a3.242 3.242 0 0 1-2.365 1.153c-.494.031-.984.135-1.476.205a.727.727 0 0 1-.93-.075.716.716 0 0 1-.045-.932z",
    transform: "translate(-1323.224 -376.953)",
    style: {
      fill: "#133b62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40349",
    d: "M1484.3 272.189a32.81 32.81 0 0 1-1.961 1.969c0-4.654-.027-9.309.007-13.963a2.009 2.009 0 0 0-1.139-2.175h1.31a1.61 1.61 0 0 1 1.778 1.766q.005 6.2.005 12.403z",
    transform: "translate(-1447.785 -254.841)",
    style: {
      fill: "#c0c0bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40350",
    d: "M1333.232 362.391h-7.588a4.471 4.471 0 0 1-.468-.012.645.645 0 0 1-.635-.629.663.663 0 0 1 .546-.758 2.006 2.006 0 0 1 .512-.031h15.27a2.153 2.153 0 0 1 .466.021.668.668 0 0 1 .592.724.647.647 0 0 1-.639.674 4.306 4.306 0 0 1-.468.012z",
    transform: "translate(-1309.521 -345.689)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40351",
    d: "M1338.5 442.642a13.185 13.185 0 0 1-1.472 1.474l-9.228-.016h-2.249c-.7 0-1.034-.242-1.028-.739s.329-.719 1.047-.72h7.121z",
    transform: "translate(-1309.507 -417.776)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40352",
    d: "M1272.022 433.629c-.483 0-.967.012-1.45 0a.765.765 0 0 1-.847-.844q-.023-1.474 0-2.948c.009-.581.285-.852.877-.862q1.45-.023 2.9 0a.77.77 0 0 1 .872.867q.024 1.45 0 2.9c-.009.609-.291.875-.9.887-.485.008-.969 0-1.452 0z",
    transform: "translate(-1261.136 -405.705)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40354",
    d: "M1272 351.979c-.483 0-.967.01-1.45 0-.547-.014-.818-.258-.828-.8q-.029-1.52 0-3.041c.011-.53.3-.78.845-.785q1.473-.012 2.946 0c.565 0 .841.256.852.826q.03 1.5 0 2.994c-.011.545-.279.789-.824.8-.516.017-1.031.006-1.541.006z",
    transform: "translate(-1261.128 -333.677)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40355",
    d: "M1448.694 231.076a1.564 1.564 0 0 1 1.973 1.493c.018.541.014 1.083.019 1.624l-.016 1.5a1.586 1.586 0 0 1-1.962 1.663.957.957 0 0 1-.181-.66v-4.953a.988.988 0 0 1 .167-.667z",
    transform: "translate(-1418.946 -231.018)",
    style: {
      fill: "#133b62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40356",
    d: "M1367.4 230.98a1.617 1.617 0 0 1 1.853 1.723c.017.482.017.965.024 1.448-.019.587.008 1.18-.066 1.76a1.535 1.535 0 0 1-1.9 1.408 1.01 1.01 0 0 1-.176-.665v-4.968c.006-.262-.012-.542.265-.706z",
    transform: "translate(-1347.115 -230.976)",
    style: {
      fill: "#133b62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40357",
    d: "M1285.989 230.976a1.584 1.584 0 0 1 1.8 1.579c0 1.042 0 2.084-.015 3.127a1.554 1.554 0 0 1-1.88 1.639.669.669 0 0 1-.17-.517 462.183 462.183 0 0 1 0-5.266.573.573 0 0 1 .265-.562z",
    transform: "translate(-1275.265 -230.972)",
    style: {
      fill: "#133b62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40358",
    d: "M1408.467 525.884a16.036 16.036 0 0 1 1.415-1.422l5.279.009c.4 0 .712.114.817.536.127.507-.2.885-.785.889-1.215.009-2.429.005-3.644 0-1.027.004-2.054-.007-3.082-.012z",
    transform: "translate(-1383.592 -489.988)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40359",
    d: "M1277.3 231a.9.9 0 0 0-.093.543v5.8a1.559 1.559 0 0 1-1.316-1.629c-.009-.515-.012-1.031-.018-1.546.006-.5.01-.993.018-1.489A1.6 1.6 0 0 1 1277.3 231z",
    transform: "translate(-1266.571 -230.999)",
    style: {
      fill: "#0354a3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40360",
    d: "M1358.844 231.012a.831.831 0 0 0-.092.5v5.843a1.625 1.625 0 0 1-1.3-1.685c-.014-.494-.013-.989-.019-1.483s.011-.964.022-1.446a1.638 1.638 0 0 1 1.389-1.729z",
    transform: "translate(-1338.558 -231.007)",
    style: {
      fill: "#0354a3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40361",
    d: "m1440.713 231.463.015 6.279a1.535 1.535 0 0 1-1.239-1.631c-.011-1.1 0-2.207 0-3.31a1.531 1.531 0 0 1 1.224-1.338z",
    transform: "translate(-1410.965 -231.405)",
    style: {
      fill: "#0354a3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40362",
    d: "M1328.854 524.579a13.511 13.511 0 0 1-1.429 1.428c-.7 0-1.4 0-2.107-.015-.511-.008-.812-.273-.818-.7a.7.7 0 0 1 .8-.721c1.181-.006 2.367.004 3.554.008z",
    transform: "translate(-1309.487 -490.083)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40363",
    d: "M1326.374 565.676a.646.646 0 0 1 .005.092c-.071.828.063.954.97.915-.578.589-1.147 1.188-1.738 1.764a.717.717 0 0 1-1.011.025.7.7 0 0 1-.009-1.009c.578-.611 1.187-1.193 1.783-1.787z",
    transform: "translate(-1309.384 -526.361)",
    style: {
      fill: "#74d8ad"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40364",
    d: "m1509.5 352.719-1.181-1.151c1.027-1.038 2-2.131 3.127-3.065a2.267 2.267 0 0 1 2.4-.292 2.059 2.059 0 0 1-.358 2.343c-.723.849-1.56 1.6-2.354 2.384a.492.492 0 0 1-.362.186 1.2 1.2 0 0 0-1.272-.405z",
    transform: "translate(-1471.719 -334.254)",
    style: {
      fill: "#dfdfde"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40365",
    d: "M1527.575 354.67c.887-.877 1.805-1.726 2.648-2.644a1.921 1.921 0 0 0 .46-1.74.8.8 0 0 1-.028-.5 2.392 2.392 0 0 1 .685 3.939c-.908.965-1.876 1.874-2.817 2.809a6.893 6.893 0 0 0-1.138-1.215.652.652 0 0 1 .19-.649z",
    transform: "translate(-1488.521 -335.833)",
    style: {
      fill: "#c0c0bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40366",
    d: "M1484.388 386.972a1.007 1.007 0 0 1-.191.652l-4.325 4.3a1.048 1.048 0 0 1-.843.413c-.7-.3-.8-.815-.247-1.373 1.324-1.336 2.658-2.662 3.987-3.993.12-.121.234-.249.35-.374.623-.361.973-.259 1.269.375z",
    transform: "translate(-1445.335 -368.135)",
    style: {
      fill: "#74d8ad"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40367",
    d: "M1283.926 442.322c0 .876 0 .876-.889.876-.851 0-.851 0-.851-.868s0-.872.891-.872c.849-.001.849-.001.849.864z",
    transform: "translate(-1272.144 -416.733)",
    style: {
      fill: "#dfdfde"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40369",
    d: "M1283.925 360.453c0 .846 0 .846-.854.846-.886 0-.886 0-.886-.909 0-.857 0-.857.856-.857.884.001.884.001.884.92z",
    transform: "translate(-1272.143 -344.433)",
    style: {
      fill: "#dedfde"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.6c188335ac4c2c31e0822dbb976f2ab5.svg";
export { ForwardRef as ReactComponent };